import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router';
import StorageConst from '@/consts/storage.const';
import AdenLocalStorage from '@/utils/storage.util';
// 使用路由懒加载分组, 如果当前在同一个模块中webpackChunkName 则写为同一个
const currentBusinessRouter = [
  {
    path: '/:type/main',
    name: 'Main',
    component: () => import(/* webpackChunkName: "layout" */ '../views/main/index.vue'),
    meta: {
      title: 'ZZ商户后台主页',
    },
  },
  {
    path: '/prize/distribute',
    name: 'Distribute',
    component: () => import(/* webpackChunkName: "layout" */ '../views/distribute/index.vue'),
    meta: {
      title: '商品核销',
      alias: '商品核销',
    },
  },
  {
    path: '/prize/free',
    name: 'PrizeFree',
    component: () => import(/* webpackChunkName: "layout" */ '../views/free/index.vue'),
    meta: {
      title: '计费服务设置',
      alias: '计费服务设置',
    },
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: "layout" */ '../views/notice/index.vue'),
    meta: {
      title: '系统消息',
      alias: '系统消息',
    },
  },
  {
    path: '/user/history',
    name: 'UserHistory',
    component: () => import(/* webpackChunkName: "layout" */ '../views/history/index.vue'),
    meta: {
      title: '用户反馈',
      alias: '用户反馈',
    },
  },
  {
    path: '/user/feed',
    name: 'FeedBack',
    component: () => import(/* webpackChunkName: "layout" */ '../views/userFeed/index.vue'),
    meta: {
      title: '用户反馈',
      alias: '用户反馈',
    },
  },
  {
    path: '/config/task',
    name: 'TaskConfig',
    component: () => import(/* webpackChunkName: "config" */ '../views/config/task/index.vue'),
    meta: {
      title: '游戏任务',
      alias: '游戏任务',
    },
  },
  {
    path: '/config/privilege',
    name: 'PrivilegeConfig',
    component: () => import(/* webpackChunkName: "config" */ '../views/config/privilege/index.vue'),
    meta: {
      title: '特权展示',
      alias: '特权展示',
    },
  },
  {
    path: '/config/sign',
    name: 'SionConfig',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/sign/index.vue'),
    meta: {
      title: '签到配置',
      alias: '签到配置',
    },
  },
  {
    path: '/config/ai/async',
    name: 'AiAsyncConfig',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/async/index.vue'),
    meta: {
      title: '数据同步',
      alias: '数据同步',
    },
  },
  {
    path: '/config/ai/notice',
    name: 'AiNoticeConfig',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/notice/index.vue'),
    meta: {
      title: '商户公告设置',
      alias: '商户公告设置',
    },
  },
  {
    path: '/config/ai/start',
    name: 'AiStartConfig',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/start/index.vue'),
    meta: {
      title: '快速启动设置',
      alias: '管理员配置',
    },
  },
  {
    path: '/config/ai/staff',
    name: 'AiAdminConfig',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/staff/index.vue'),
    meta: {
      title: '管理员配置',
      alias: '快速启动设置',
    },
  },
  {
    path: '/config/charging',
    name: 'ChargingConfig',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/charging/index.vue'),
    meta: {
      title: '计费服务器配置',
      alias: '计费服务器配置',
    },
  },
  // 每日任务
  {
    path: '/activity/daily/tasks',
    name: 'DailyTasks',
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/daily/index.vue'),
    meta: {
      title: '每日任务',
      alias: '每日任务',
    },
  },
  {
    path: '/activity/challenge/tasks',
    name: 'ChallengeTasks',
    component: () =>
      import(/* webpackChunkName: "activity" */ '@/views/activity/challenge/index.vue'),
    meta: {
      title: '挑战任务',
      alias: '挑战任务',
    },
  },
  {
    path: '/game/spontaneous',
    name: 'GameSpontaneous',
    component: () => import(/* webpackChunkName: "event" */ '@/views/event/spontaneous/index.vue'),
    meta: {
      title: '自发赛',
      alias: '自发赛',
    },
  },
  // 添加自发赛的
  {
    path: '/add/game/spontaneous/:type',
    name: 'AddGameSpontaneous',
    component: () =>
      import(/* webpackChunkName: "event" */ '@/views/event/spontaneous/Encap/add.vue'),
    meta: {
      title: '添加赛事',
      alias: '添加赛事',
    },
  },
  {
    path: '/game/amuse',
    name: 'GameAmuse',
    component: () => import(/* webpackChunkName: "event" */ '@/views/event/amuse/index.vue'),
    meta: {
      title: '娱乐赛',
      alias: '娱乐赛',
    },
  },
  // 赛事详情
  {
    path: '/game/store/info',
    name: 'GameInfo',
    component: () =>
      import(/* webpackChunkName: "event" */ '@/views/event/spontaneous/Encap/detail.vue'),
    meta: {
      title: '赛事详情',
      alias: '赛事详情',
    },
  },
  // 编辑权限
  {
    path: '/edit/role/permission/:id/:name',
    name: 'EditRolePermission',
    component: () =>
      import(/* webpackChunkName: "event" */ '@/views/config/staff/Encap/editRule.vue'),
    meta: {
      title: '编辑权限',
      alias: '编辑权限',
    },
  },
  // 商户后台连锁管理
  {
    path: '/config/chain',
    name: 'ConfigChain',
    component: () => import(/* webpackChunkName: "event" */ '@/views/config/chain/index.vue'),
    meta: {
      title: '编辑权限',
      alias: '编辑权限',
    },
  },
  // 商户连锁管理
  {
    path: '/business/chain',
    name: 'BusinessChain',
    component: () => import(/* webpackChunkName: "event" */ '@/views/business/chain/index.vue'),
    meta: {
      title: '商户连锁管理',
      alias: '商户连锁管理',
    },
  },
  {
    path: '/config/ai/ram/:tabs?',
    name: 'ConfigRam',
    component: () => import(/* webpackChunkName: "event" */ '@/views/config/staff/index.vue'),
    meta: {
      title: '员工管理',
      alias: '员工管理',
    },
  },
  // // 屏保设置
  {
    path: '/config/screen/saver',
    name: 'ScreenSaver',
    component: () => import(/* webpackChunkName: "event" */ '@/views/config/screen/index.vue'),
    meta: {
      title: '屏保设置',
      alias: '屏保设置',
    },
  },
  {
    path: '/config/desk/icon',
    name: 'AiDeskTopIcon',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/icon/index.vue'),
    meta: {
      title: '桌面图标管理',
      alias: '桌面图标管理',
    },
  },
  // 商超
  {
    path: '/category/management',
    name: 'CategoryManagement',
    component: () => import(/* webpackChunkName: "config" */ '@/views/goods/category.vue'),
    meta: {
      title: '分类管理',
      alias: '分类管理',
    },
  },
  {
    path: '/product/management',
    name: 'ProductManagement',
    component: () => import(/* webpackChunkName: "config" */ '@/views/goods/product.vue'),
    meta: {
      title: '商品管理',
      alias: '商品管理',
    },
  },
  {
    path: '/payment/management',
    name: 'PaymentManagement',
    component: () => import(/* webpackChunkName: "config" */ '@/views/goods/payment.vue'),
    meta: {
      title: '商品管理',
      alias: '商品管理',
    },
  },
  {
    path: '/add/payment',
    name: 'AddManagement',
    component: () => import(/* webpackChunkName: "config" */ '@/views/goods/Encap/payment.vue'),
    meta: {
      title: '添加商品',
      alias: '添加商品',
    },
  },
  {
    path: '/sales/records',
    name: 'SalesRecords',
    component: () => import(/* webpackChunkName: "config" */ '@/views/goods/sales.vue'),
    meta: {
      title: '商品销售记录',
      alias: '商品销售记录',
    },
  },
  {
    path: '/chargeback/records',
    name: 'ChargebackRecords',
    component: () => import(/* webpackChunkName: "config" */ '@/views/goods/chargeback.vue'),
    meta: {
      title: '退单记录',
      alias: '退单记录',
    },
  },
  {
    path: '/change/shifts',
    name: 'ChangeShifts',
    component: () => import(/* webpackChunkName: "config" */ '@/views/handover/changeShifts.vue'),
    meta: {
      title: '交接班管理',
      alias: '交接班管理',
    },
  },
  {
    path: '/config/fesoc/game',
    name: 'FesocGame',
    component: () => import('@/views/config/fesoc/index.vue'),
  },
];
const routes: Array<RouteRecordRaw> = [
  { path: '/', redirect: '/login' },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/index.vue'),
  },
  {
    path: '/login/:chain?',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/index.vue'),
  },
  {
    path: '/business/list',
    name: 'BusinessList',
    component: () => import(/* webpackChunkName: "login" */ '../views/MultiplePos/MultiplePos.vue'),
  },
  {
    path: '/layout',
    name: 'Layout',
    component: () => import(/* webpackChunkName: "layout" */ '../layout/index.vue'),
    redirect: '/:type/main',
    children: currentBusinessRouter,
  },
  // 桌面配置需要全屏展示
  {
    path: '/config/ai/desktop',
    name: 'AiDeskTopConfig',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/desktop/index.vue'),
  },
  // 美团桌面配置 需要全屏展示
  {
    path: '/config/meituan/desktop',
    name: 'MTDeskTopConfig',
    component: () => import(/* webpackChunkName: "config" */ '@/views/config/meituan/index.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to: any, from, next) => {
  if (to.name === 'not-found') {
    // 清除本地存储的登录信息
    AdenLocalStorage.clearAll();
    router.push('/');
    return; // 防止后续代码执行
  }
  // 更新文档标题
  if (to.path === '/login' && AdenLocalStorage.get('lastRouter')) {
    router.push(AdenLocalStorage.get('lastRouter'));
  }
  if (
    to.path !== '/login' &&
    to.path !== '/config/ai/desktop' &&
    to.path !== '/config/meituan/desktop'
  ) {
    AdenLocalStorage.set('lastRouter', to.path);
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 更新当前路由到本地存储
  next(); // 继续导航
});

export default router;
